// frontend/src/utils/quizTranslations.js
// Quiz-specific translations for burnair Academy

export const quizTranslations = {
  // Quiz Types
  quizTypes: {
    practice: {
      de: "Übung",
      en: "Practice",
    },
    graded: {
      de: "Benotet",
      en: "Graded",
    },
    pre_assessment: {
      de: "Vorabprüfung",
      en: "Pre-Assessment",
    },
    post_assessment: {
      de: "Abschlussprüfung",
      en: "Post-Assessment",
    },
  },

  // Question Types
  questionTypes: {
    multiple_choice: {
      de: "Einfachauswahl",
      en: "Multiple Choice",
    },
    multiple_select: {
      de: "Mehrfachauswahl",
      en: "Multiple Select",
    },
    true_false: {
      de: "Wahr/Falsch",
      en: "True/False",
    },
    fill_blank: {
      de: "Lückentext",
      en: "Fill in the Blank",
    },
  },

  // UI Labels
  ui: {
    startQuiz: {
      de: "Quiz starten",
      en: "Start Quiz",
    },
    continueQuiz: {
      de: "Quiz fortsetzen",
      en: "Continue Quiz",
    },
    retakeQuiz: {
      de: "Quiz wiederholen",
      en: "Retake Quiz",
    },
    submitAnswer: {
      de: "Antwort abgeben",
      en: "Submit Answer",
    },
    nextQuestion: {
      de: "Nächste Frage",
      en: "Next Question",
    },
    previousQuestion: {
      de: "Vorherige Frage",
      en: "Previous Question",
    },
    submitQuiz: {
      de: "Quiz abschließen",
      en: "Submit Quiz",
    },
    questions: {
      de: "Fragen",
      en: "Questions",
    },
    question: {
      de: "Frage",
      en: "Question",
    },
    of: {
      de: "von",
      en: "of",
    },
    passingScore: {
      de: "Bestehensgrenze",
      en: "Passing Score",
    },
    yourScore: {
      de: "Ihre Punktzahl",
      en: "Your Score",
    },
    timeRemaining: {
      de: "Verbleibende Zeit",
      en: "Time Remaining",
    },
    timeLimit: {
      de: "Zeitlimit",
      en: "Time Limit",
    },
    attemptsRemaining: {
      de: "Verbleibende Versuche",
      en: "Attempts Remaining",
    },
    unlimited: {
      de: "Unbegrenzt",
      en: "Unlimited",
    },
    selectAnswer: {
      de: "Wählen Sie eine Antwort",
      en: "Select an answer",
    },
    selectAnswers: {
      de: "Wählen Sie alle zutreffenden Antworten",
      en: "Select all that apply",
    },
    correct: {
      de: "Korrekt",
      en: "Correct",
    },
    incorrect: {
      de: "Nicht korrekt",
      en: "Incorrect",
    },
    explanation: {
      de: "Erklärung",
      en: "Explanation",
    },
    learnMore: {
      de: "Lerne mehr zum Thema",
      en: "Learn More about that Topic",
    },
    answered: {
      de: "beantwortet",
      en: "answered",
    },
    cancel: {
      de: "Abbrechen",
      en: "Cancel",
    },
    clickToEnlarge: {
      de: "Zum Vergrößern klicken",
      en: "Click to enlarge",
    },
    zoomIn: {
      de: "Vergrößern",
      en: "Zoom in",
    },
    zoomOut: {
      de: "Verkleinern",
      en: "Zoom out",
    },
    resetZoom: {
      de: "Zurücksetzen",
      en: "Reset",
    },
  },

  // Results
  results: {
    congratulations: {
      de: "Herzlichen Glückwunsch!",
      en: "Congratulations!",
    },
    passed: {
      de: "Sie haben bestanden!",
      en: "You passed!",
    },
    failed: {
      de: "Nicht bestanden",
      en: "Not Passed",
    },
    tryAgain: {
      de: "Versuche es erneut",
      en: "Try Again",
    },
    score: {
      de: "Punktzahl",
      en: "Score",
    },
    points: {
      de: "Punkte",
      en: "Points",
    },
    timeTaken: {
      de: "Benötigte Zeit",
      en: "Time Taken",
    },
    correctAnswers: {
      de: "Richtige Antworten",
      en: "Correct Answers",
    },
    reviewAnswers: {
      de: "Antworten überprüfen",
      en: "Review Answers",
    },
    backToQuiz: {
      de: "Zurück",
      en: "Back",
    },
    badgeEarned: {
      de: "Abzeichen verdient!",
      en: "Badge Earned!",
    },
  },

  // Messages
  messages: {
    loginRequired: {
      de: "Bitte melden Sie sich an, um dieses Quiz zu starten",
      en: "Please log in to start this quiz",
    },
    accessDenied: {
      de: "Sie haben keinen Zugriff auf dieses Quiz",
      en: "You do not have access to this quiz",
    },
    noAttemptsLeft: {
      de: "Sie haben keine Versuche mehr übrig",
      en: "You have no attempts remaining",
    },
    quizNotFound: {
      de: "Quiz nicht gefunden",
      en: "Quiz not found",
    },
    loadingQuiz: {
      de: "Quiz wird geladen...",
      en: "Loading quiz...",
    },
    submittingAnswer: {
      de: "Antwort wird übermittelt...",
      en: "Submitting answer...",
    },
    submittingQuiz: {
      de: "Quiz wird abgeschlossen...",
      en: "Submitting quiz...",
    },
    errorLoadingQuiz: {
      de: "Fehler beim Laden des Quiz",
      en: "Error loading quiz",
    },
    errorSubmittingAnswer: {
      de: "Fehler beim Übermitteln der Antwort",
      en: "Error submitting answer",
    },
    errorSubmittingQuiz: {
      de: "Fehler beim Abschließen des Quiz",
      en: "Error submitting quiz",
    },
    confirmSubmit: {
      de: "Möchten Sie das Quiz wirklich abschließen? Sie können Ihre Antworten danach nicht mehr ändern.",
      en: "Are you sure you want to submit the quiz? You cannot change your answers afterwards.",
    },
    confirmSubmitTitle: {
      de: "Quiz abschließen?",
      en: "Submit Quiz?",
    },
  },

  // Stats
  stats: {
    bestScore: {
      de: "Beste Punktzahl",
      en: "Best Score",
    },
    completed: {
      de: "Abgeschlossen",
      en: "Completed",
    },
    notStarted: {
      de: "Nicht gestartet",
      en: "Not Started",
    },
    inProgress: {
      de: "In Bearbeitung",
      en: "In Progress",
    },
  },

  // Time formatting
  time: {
    minutes: {
      de: "Minuten",
      en: "minutes",
    },
    minute: {
      de: "Minute",
      en: "minute",
    },
    seconds: {
      de: "Sekunden",
      en: "seconds",
    },
    second: {
      de: "Sekunde",
      en: "second",
    },
  },
};

// Helper function to get translated text
export const getQuizTranslation = (path, language = "de") => {
  const keys = path.split(".");
  let value = quizTranslations;

  for (const key of keys) {
    if (!value[key]) return path; // Return path if translation not found
    value = value[key];
  }

  return value[language] || value["en"] || path;
};

// Helper to format time
export const formatQuizTime = (seconds, language = "de") => {
  if (!seconds) return "";

  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  const parts = [];

  if (mins > 0) {
    const minText =
      mins === 1
        ? getQuizTranslation("time.minute", language)
        : getQuizTranslation("time.minutes", language);
    parts.push(`${mins} ${minText}`);
  }

  if (secs > 0 || parts.length === 0) {
    const secText =
      secs === 1
        ? getQuizTranslation("time.second", language)
        : getQuizTranslation("time.seconds", language);
    parts.push(`${secs} ${secText}`);
  }

  return parts.join(" ");
};
